// Opt-in client-side performance instrumentation for the Transaction Analysis
// surface. This module ADDS NO BEHAVIOR — it only measures. It logs PRIMITIVES
// ONLY (timings + counts), never transaction arrays/objects, so it cannot retain
// references or leak memory the way the debug logs removed in the phase-0 OOM
// fix did.
//
// Silent unless explicitly enabled for a profiling run:
//   - append ?perf=1 to the URL, or
//   - run localStorage.setItem('livi_perf', '1') in the console (persists), then reload.
// Disable again with localStorage.removeItem('livi_perf') (and drop ?perf=1).
let _enabled;

export function perfEnabled() {
  if (_enabled === undefined) {
    _enabled = false;
    try {
      const qs = new URLSearchParams(window.location.search);
      _enabled =
        qs.get('perf') === '1' ||
        window.localStorage.getItem('livi_perf') === '1';
    } catch (_e) {
      _enabled = false;
    }
  }
  return _enabled;
}

// High-resolution monotonic clock when available; cheap and always safe to call.
export function perfNow() {
  return typeof performance !== 'undefined' && performance.now
    ? performance.now()
    : Date.now();
}

// Log one measurement. `fields` MUST be a small object of primitives only
// (numbers / strings / booleans) — never pass a transaction array or nested
// object, or we reintroduce the retained-reference leak.
export function perfLog(label, fields) {
  if (!perfEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(`[perf] ${label}`, fields);
}
